import React, { PureComponent } from 'react'
import {
    Box,
    Grid,
    Tooltip,
    Menu,
    MenuItem,
    Select,
    Button,
    ButtonGroup,
} from '@mui/material'
import TemplateInstall from '../Template/TemplateInstall'
import ExpiredModal from './Upgrade/ExpiredModal'
import BlockLazy from './MyPage/BlockLazy'
import { WidthProvider, Responsive } from 'react-grid-layout'
import { LoadingDefault } from '@/shared/ui/loading'
import LoadingPage from '@/shared/composed-ui/LoadingPage'
import { useReactToPrint } from 'react-to-print'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint } from '@fortawesome/pro-duotone-svg-icons/faPrint'
import { faTimer } from '@fortawesome/pro-duotone-svg-icons/faTimer'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes'
import { faExpand } from '@fortawesome/pro-duotone-svg-icons/faExpand'
import { faSquareDashedCirclePlus } from '@fortawesome/pro-duotone-svg-icons/faSquareDashedCirclePlus'
import { faCalendarRange } from '@fortawesome/pro-duotone-svg-icons/faCalendarRange'
import { faEyeSlash } from '@fortawesome/pro-duotone-svg-icons/faEyeSlash'
import { faToggleLargeOn } from '@fortawesome/pro-duotone-svg-icons/faToggleLargeOn'
import { faCaretDown } from '@fortawesome/pro-duotone-svg-icons/faCaretDown'

import BlockGeomap from './MyPage/BlockGeomap'
import BlockForm from '../Admin/Pages/Blocks/BlockForm'
import {
    BlockDisplay,
    BlockContainerDisplay,
    CountListBlock,
    CountLinkBlock,
    SumFieldsBlock,
    UserStatisticsBlock,
    DateStatisticsBlock,
    SupersetBlock,
    FunnelBlock,
    PercentageMatchingBlock,
    UserMostActiveStatisticsBlock,
} from '@/feature/admin/Blocks/Components/Display'
import AppDialog from '@/shared/ui/app-dialog/AppDialog'
import { brandedTokens } from '@/theme/tokens'

const ResponsiveReactGridLayout = WidthProvider(Responsive)

function PrintButton({ contentRef, children, ...buttonProps }) {
    const handlePrint = useReactToPrint({ contentRef })
    return (
        <Button onClick={() => handlePrint()} {...buttonProps}>
            {children}
        </Button>
    )
}

function PrintTooltipButton({ contentRef, title, children }) {
    const handlePrint = useReactToPrint({ contentRef })
    return (
        <Tooltip title={title} arrow>
            <Button onClick={() => handlePrint()}>{children}</Button>
        </Tooltip>
    )
}

class MyPage extends PureComponent {
    constructor(props) {
        super(props)
        this.selectorRef = React.createRef()
        this.otherSelectorRef = React.createRef()
        this.observer = null
        this.didGridDrag = false
        this.state = {
            makeReport: false,
            dateFormat: null,
            refreshRate: null,
            expandBlock: null,
            refreshInt: null,
            savingPos: false,
            pos_default: false,
            grayedDateBlocks: '',
            loading: false,
            toggleDrag: false,
            subscriptionExpired: null,
            blocks: [],
            hasMore: true,
            hiddenBlocks: [],
            layout: [],
            isActivated: false,
            presentation: false,
            newBlock: false,
            toggleIcon: true,
            refreshAnchor: null,
            dateAnchor: null,
        }

        this.onLayoutChange = this.onLayoutChange.bind(this)
        this.submitPositions = this.submitPositions.bind(this)
        this.updateData = this.updateData.bind(this)
        this.changeDateBlocks = this.changeDateBlocks.bind(this)
        this.changeRefreshRate = this.changeRefreshRate.bind(this)
        this.hideBlock = this.hideBlock.bind(this)
        this.saveAndRefresh = this.saveAndRefresh.bind(this)
        this.getBlockHeader = this.getBlockHeader.bind(this)
        this.revertHiddenBlocks = this.revertHiddenBlocks.bind(this)
    }

    handleGridDrag = () => {
        this.didGridDrag = true
    }

    handleGridDragStop = () => {
        this.setState({ moved: true })
    }

    handleGridClickCapture = (event) => {
        if (!this.didGridDrag) {
            return
        }

        this.didGridDrag = false
        event.preventDefault()
        event.stopPropagation()
    }

    openRefreshMenu = (e) => {
        this.setState({ refreshAnchor: e.currentTarget })
    }

    openDateMenu = (e) => {
        this.setState({
            dateAnchor: e.currentTarget,
            grayedDateBlocks: ' kedo-block-grayed-dates',
        })
    }

    closeMenus = () => {
        this.setState({
            refreshAnchor: null,
            dateAnchor: null,
            grayedDateBlocks: '',
        })
    }

    handleFullScreenChange = () => {
        if (!document.fullscreenElement && this.isActivated) {
            this.moodPresentation()
            this.presentfullScreen()
        }
    }

    presentfullScreen() {
        if (this.isActivated) {
            document.documentElement.requestFullscreen()
        } else {
            document.exitFullscreen()
        }
    }

    saveAndRefresh(blockId) {
        let api = this.props.kedo.api()
        this.setState({ blockLoading: blockId })
        api.get(api.getMyPageBlockEndpoint(blockId)).then((blockResponse) => {
            const updated = blockResponse.data
            const blocks = this.state.blocks.map((block) =>
                block.id === blockId
                    ? { ...block, ...updated, settings: updated.settings }
                    : block
            )

            this.setState({ blocks, blockLoading: null }, () =>
                this['blockRef' + blockId].current?.fetchData?.()
            )
        })
    }

    revertHiddenBlocks() {
        this.setState({ loading: true })
        let blocks = [...this.state.blocks]
        let layout = [...this.state.layout]

        this.state.hiddenBlocks.forEach((item) => {
            blocks.push(item.blocks)
            layout.push(item.layout)
        })

        this.setState({
            loading: false,
            layout: layout,
            blocks: blocks,
            hiddenBlocks: [],
        })
    }

    hideBlock(uuid) {
        this.setState({ loading: true })
        let blocks = this.state.blocks.filter((item) => item.uuid !== uuid)
        let layout = this.state.layout.filter((item) => item.i !== uuid)
        let hidden = this.state.hiddenBlocks

        hidden.push({
            layout: this.state.layout.find((item) => item.i === uuid),
            blocks: this.state.blocks.find((item) => item.uuid === uuid),
        })

        this.setState({
            loading: false,
            layout: layout,
            blocks: blocks,
            hiddenBlocks: hidden,
        })
    }

    fetchMyPageBlocks() {
        let api = this.props.kedo.api()
        let environment = this.props.kedo.env().getEnvironment()
        if (!environment) {
            return
        }

        let params = {
            params: {
                dashboard: true,
                environment: environment.id,
                default: this.state.pos_default,
            },
        }

        this.setState({ loading: true })
        api.get(api.getMyPageBlockEndpoint(), params).then((response) => {
            let layout = []

            for (let i = 0; i < response.data.positions.length; i++) {
                layout.push({
                    x: response.data.positions[i].x,
                    y: response.data.positions[i].y,
                    w:
                        response.data.positions[i].w <= 0
                            ? 5
                            : response.data.positions[i].w,
                    h:
                        response.data.positions[i].h <= 0
                            ? 5
                            : response.data.positions[i].h,
                    i: response.data.positions[i].uuid,
                    minW: 5,
                    minH: 5,
                })
            }

            //Add default for new blocks
            for (let b = 0; b < response.data.results.length; b++) {
                this['blockRef' + response.data.results[b].id] =
                    React.createRef()
                this['divBlockRef' + response.data.results[b].id] =
                    React.createRef()

                let isExisting = layout.find(
                    (lItem) => lItem.i === response.data.results[b].uuid
                )
                if (!isExisting) {
                    layout.push({
                        x: (b * 6) % 12,
                        y: 0,
                        w: 6,
                        h: 10,
                        i: response.data.results[b].uuid,
                        minW: 5,
                        minH: 5,
                    })
                }
            }

            this.setState({
                loading: false,
                layout,
                blocks: response.data.results,
                pagerBlocks: response.data.pager,
            })
        })
    }

    checkContract() {
        let api = this.props.kedo.api()
        api.get(api.getOwnActiveSubscriptionEndpoint()).then((response) => {
            if (!response.data.subscription && response.data.expired) {
                this.setState({ subscriptionExpired: true })
            }
        })
    }

    renderExpired() {
        return <ExpiredModal kedo={this.props.kedo} />
    }

    componentDidMount() {
        if (this.props.kedo.isContractAdmin()) {
            this.checkContract()
        }

        this.fetchMyPageBlocks()
        this.props.kedo.title().set(this.props.kedo.t('Dashboard'))
        document.addEventListener(
            'fullscreenchange',
            this.handleFullScreenChange
        )
    }

    getBlockHeader(block, dossier) {
        if (!block || (dossier && dossier.id)) {
            return ''
        }

        const titleSx = this.state.expandBlock
            ? {
                  fontSize: '1.5rem',
                  fontWeight: 700,
                  lineHeight: 1.3,
                  m: 0,
              }
            : undefined

        const title = this.props.kedo.env().translateItem(block, 'mypageblock')

        if (block.def_dossier_id) {
            return (
                <Box component="h4" sx={titleSx}>
                    <a href={`/defdossier/${block.def_dossier_id}`}>{title}</a>
                </Box>
            )
        }

        return (
            <Box component="h4" sx={titleSx}>
                {title}
            </Box>
        )
    }

    renderMyPageBlock(item, kedo, enlarged) {
        let blockProps = {
            kedo: kedo,
            block: item,
            dashboard: true,
            onClose: this.hideBlock,
            ref: enlarged === false ? this['blockRef' + item.id] : null,
            onSuccess: this.saveAndRefresh,
            getBlockHeader: this.getBlockHeader,
            onMax: (uuid) => this.setState({ expandBlock: uuid }),
        }

        switch (item.type) {
            case 'block_container':
                return <BlockContainerDisplay {...blockProps} />
            case 'dashboard':
                return <BlockDisplay {...blockProps} />
            case 'count_list_options':
                return <CountListBlock {...blockProps} />
            case 'list_option_percentage_conditions':
                return <PercentageMatchingBlock {...blockProps} />
            case 'count_link_options':
                return <CountLinkBlock {...blockProps} />
            case 'sum_fields':
                return <SumFieldsBlock {...blockProps} />
            case 'new_dossier_statistics':
                return <DateStatisticsBlock {...blockProps} />
            case 'active_users':
                return <UserMostActiveStatisticsBlock {...blockProps} />
            case 'online_users':
                return <UserStatisticsBlock {...blockProps} />
            case 'date_statistics':
                return <DateStatisticsBlock {...blockProps} />
            case 'geomap':
                return <BlockGeomap {...blockProps} />
            case 'funnel':
                return <FunnelBlock {...blockProps} />
            case 'kedo_charts':
                return <SupersetBlock {...blockProps} />
        }

        return ''
    }

    onLayoutChange(layout) {
        this.setState(
            {
                layout: layout,
            },
            this.state.toggleDrag ? this.submitPositions : null
        )
    }

    submitPositions() {
        let api = this.props.kedo.api()
        let envId = this.props.kedo.env().getEnvironment().id
        let payload = []
        for (let i = 0; i < this.state.layout.length; i++) {
            payload.push({
                block: this.state.layout[i].i,
                xPos: this.state.layout[i].x,
                yPos: this.state.layout[i].y,
                blockWidth: this.state.layout[i].w,
                blockHeight: this.state.layout[i].h,
            })
        }

        let dataPayload = { blocks: payload }

        if (this.state.pos_default === true) {
            dataPayload.default = true
        }

        this.setState({ savingPos: true })
        api.patch('/mypage/' + envId + '/position', dataPayload).then(
            (response) => this.setState({ savingPos: false })
        )
    }

    setAndGetDefaultPositions() {
        let api = this.props.kedo.api()
        let envId = this.props.kedo.env().getEnvironment().id

        this.setState(
            {
                loading: true,
            },
            () => {
                let params = { params: {} }
                if (this.state.pos_default) {
                    params.params.default = true
                }

                api.get('/mypage/' + envId + '/position', params).then(
                    (response) => {
                        let layout = []

                        for (let i = 0; i < response.data.length; i++) {
                            layout.push({
                                x: response.data[i].x,
                                y: response.data[i].y,
                                w:
                                    response.data[i].w <= 0
                                        ? 5
                                        : response.data[i].w,
                                h:
                                    response.data[i].h <= 0
                                        ? 5
                                        : response.data[i].h,
                                i: response.data[i].uuid,
                                minW: 5,
                                minH: 5,
                            })
                        }

                        this.setState({ loading: false, layout: layout })
                    }
                )
            }
        )
    }

    updateData(dataName, dataVal) {
        this.setState({ [dataName]: dataVal })
    }

    changeRefreshRate(eventKey) {
        if (this.state.refreshInt) {
            clearInterval(this.state.refreshInt)
        }

        let defRefRate = 30 * 60 * 1000

        if (eventKey === 'minute') {
            defRefRate = 60000
        } else if (eventKey === 'five_minute') {
            defRefRate = 5 * 60 * 1000
        } else if (eventKey === 'fifteen_minute') {
            defRefRate = 15 * 60 * 1000
        } else if (eventKey === 'thirty_minute') {
            defRefRate = 30 * 60 * 1000
        }

        let refreshInt = setInterval(() => {
            this.state.blocks.map((blockItem) => {
                let blockRefId = 'blockRef' + blockItem.id
                if (
                    this[blockRefId] &&
                    this[blockRefId].current &&
                    this[blockRefId].current &&
                    this[blockRefId].current.fetchData
                ) {
                    /**
                     * Check if an element is in viewport
                     *
                     * @param {number} [offset]
                     * @returns {boolean}
                     */
                    let eOffset = 0
                    if (this[blockRefId].current.getParentRef) {
                        const eTop = this[blockRefId].current
                            .getParentRef()
                            .current.getBoundingClientRect().top
                        if (
                            eTop + eOffset >= 0 &&
                            eTop - eOffset <= window.innerHeight
                        ) {
                            this[blockRefId].current.fetchData(false)
                        }
                    }
                }
            })
        }, defRefRate)
        this.setState({
            refreshRate: eventKey,
            refreshInt: refreshInt,
        })
        this.closeMenus()
    }

    changeDateBlocks(eventKey) {
        this.setState({ dateFormat: eventKey }, () => {
            this.state.blocks.map((blockItem) => {
                let blockRefId = 'blockRef' + blockItem.id
                if (
                    this[blockRefId] &&
                    this[blockRefId].current &&
                    this[blockRefId].current.setFilterAndFetchData
                ) {
                    this[blockRefId].current.setFilterAndFetchData(
                        'dateFormat',
                        eventKey
                    )
                }
            })
        })
        this.closeMenus()
    }

    moodPresentation() {
        if (typeof this.state.openSidebar === 'undefined') {
            this.presentation = false
        } else {
            this.presentation = !this.state.openSidebar
        }

        this.isActivated = !this.state.isActivated
        this.setState({
            openSidebar: this.presentation,
            isActivated: this.isActivated,
        })
        this.props.onCloseSidebar(this.presentation)
    }

    componentWillUnmount() {
        clearInterval(this.state.refreshInt)
    }

    renderExpandedBlock(uuid) {
        let block = this.state.blocks.find((block) => block.uuid === uuid)
        const kedo = this.props.kedo
        let mHeight = window.innerHeight - 100

        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'xl'}
                fullWidth
                title={''}
                onClose={() => this.setState({ expandBlock: null })}
                contentProps={{ dividers: true }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row-reverse',
                        alignItems: 'flex-start',
                        height: mHeight,
                        minHeight: 0,
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            flexShrink: 0,
                            mb: 1,
                            ml: 1,
                        }}
                    >
                        <ButtonGroup
                            variant="outlined"
                            sx={{
                                '& .MuiButton-root': {
                                    height: 28,
                                    color: brandedTokens.brand.secondary.dark,
                                    borderColor:
                                        brandedTokens.brand.secondary.dark,
                                    backgroundColor: '#fff',
                                    textTransform: 'none',
                                    boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
                                    '&:hover': {
                                        boxShadow:
                                            '0px 4px 10px rgba(0,0,0,0.2)',
                                    },
                                },
                            }}
                        >
                            <PrintButton
                                contentRef={this.otherSelectorRef}
                                aria-label={kedo.t('Print')}
                            >
                                <FontAwesomeIcon icon={faPrint} />
                            </PrintButton>
                            <Button
                                onClick={() =>
                                    this.setState({ expandBlock: null })
                                }
                                aria-label={kedo.t('Close')}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </Button>
                        </ButtonGroup>
                    </Box>

                    <Box
                        component="div"
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            alignSelf: 'stretch',
                            overflowY: 'auto',
                        }}
                        ref={this.otherSelectorRef}
                    >
                        <style type="text/css" media="print">
                            {
                                '@\
                            @media print {\
                            @page { size: landscape; }\
                            }\
                            page { size: landscape; }\
                        '
                            }
                        </style>

                        {this.state.blockLoading === block.id ? (
                            <center>
                                <LoadingDefault />
                            </center>
                        ) : (
                            this.renderMyPageBlock(block, kedo, true)
                        )}
                    </Box>
                </Box>
            </AppDialog>
        )
    }

    handleToggle = () => {
        this.setState(
            (prevState) => ({
                toggleIcon: !prevState.toggleIcon,
                toggleDrag: !prevState.toggleDrag,
            }),
            () => {
                if (this.state.pos_default) {
                    this.setAndGetDefaultPositions()
                }
                this.revertHiddenBlocks()
            }
        )
    }

    render() {
        const { toggleIcon, refreshAnchor, dateAnchor } = this.state
        const kedo = this.props.kedo
        let hasTemplate =
            kedo.isAdminOrEnvironmentAdmin() && kedo.env().hasTemplate()

        if (this.state.loading) {
            return (
                <div className="mypage" data-cy="dashboard-main">
                    <LoadingPage />
                </div>
            )
        }

        return (
            <div className="mypage" data-cy="dashboard-main">
                {this.state.expandBlock
                    ? this.renderExpandedBlock(this.state.expandBlock)
                    : null}
                {this.state.newBlock ? (
                    <BlockForm
                        variant={'new'}
                        kedo={kedo}
                        onSuccess={() => {
                            this.fetchMyPageBlocks()
                            this.setState({ newBlock: false })
                        }}
                        onClose={() => this.setState({ newBlock: false })}
                    />
                ) : null}
                <Grid container>
                    <Grid marginLeft={'auto'}>
                        <ButtonGroup
                            variant="outlined"
                            sx={{
                                '& .MuiButton-root': {
                                    height: 'auto',
                                    color: brandedTokens.brand.secondary.dark,
                                    borderColor:
                                        brandedTokens.brand.secondary.dark,
                                    backgroundColor: '#fff',
                                    textTransform: 'none',
                                    boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
                                    '&:hover': {
                                        boxShadow:
                                            '0px 4px 10px rgba(0,0,0,0.2)',
                                    },
                                },
                            }}
                        >
                            {kedo.hasPermissionFor(
                                'kedo.mypageblocks.create'
                            ) && (
                                <Tooltip title={kedo.t('Add Block')} arrow>
                                    <Button
                                        onClick={() =>
                                            this.setState({
                                                newBlock: true,
                                            })
                                        }
                                        aria-label={kedo.t('Add Block')}
                                    >
                                        <FontAwesomeIcon
                                            icon={faSquareDashedCirclePlus}
                                        />
                                    </Button>
                                </Tooltip>
                            )}

                            <Tooltip
                                title={kedo.t(
                                    this.state.isActivated
                                        ? 'Minimize'
                                        : 'Maximize'
                                )}
                                arrow
                            >
                                <Button
                                    onClick={() => {
                                        this.moodPresentation()
                                        this.presentfullScreen()
                                    }}
                                >
                                    <FontAwesomeIcon icon={faExpand} />
                                </Button>
                            </Tooltip>

                            <Tooltip
                                title={kedo.t(
                                    this.state.refreshRate || 'Refresh'
                                )}
                                arrow
                            >
                                <Button
                                    endIcon={
                                        <FontAwesomeIcon
                                            icon={faCaretDown}
                                            size="sm"
                                        />
                                    }
                                    sx={{
                                        height: '40px',
                                        '& .MuiButton-endIcon svg ': {
                                            fontSize: '16px',
                                        },
                                    }}
                                    onClick={this.openRefreshMenu}
                                >
                                    <FontAwesomeIcon icon={faTimer} />
                                </Button>
                            </Tooltip>

                            <Menu
                                anchorEl={refreshAnchor}
                                open={Boolean(refreshAnchor)}
                                onClose={this.closeMenus}
                            >
                                <MenuItem
                                    onClick={() =>
                                        this.changeRefreshRate('thirty_minute')
                                    }
                                >
                                    {'30 ' + kedo.t('minutes')}
                                </MenuItem>

                                <MenuItem
                                    onClick={() =>
                                        this.changeRefreshRate('fifteen_minute')
                                    }
                                >
                                    {'15 ' + kedo.t('minutes')}
                                </MenuItem>

                                <MenuItem
                                    onClick={() =>
                                        this.changeRefreshRate('five_minute')
                                    }
                                >
                                    {'5 ' + kedo.t('minutes')}
                                </MenuItem>

                                <MenuItem
                                    onClick={() =>
                                        this.changeRefreshRate('minute')
                                    }
                                >
                                    {'1 ' + kedo.t('minute')}
                                </MenuItem>
                            </Menu>

                            <Tooltip
                                title={kedo.t(
                                    this.state.dateFormat || 'Choose an option'
                                )}
                                arrow
                            >
                                <Button
                                    endIcon={
                                        <FontAwesomeIcon
                                            icon={faCaretDown}
                                            size="sm"
                                        />
                                    }
                                    sx={{
                                        height: '40px',
                                        '& .MuiButton-endIcon svg ': {
                                            fontSize: '16px',
                                        },
                                    }}
                                    onClick={this.openDateMenu}
                                >
                                    <FontAwesomeIcon icon={faCalendarRange} />
                                </Button>
                            </Tooltip>

                            <Menu
                                anchorEl={dateAnchor}
                                open={Boolean(dateAnchor)}
                                onClose={this.closeMenus}
                            >
                                <MenuItem
                                    onClick={() =>
                                        this.changeDateBlocks('year_month')
                                    }
                                >
                                    {kedo.t('year_month')}
                                </MenuItem>

                                <MenuItem
                                    onClick={() =>
                                        this.changeDateBlocks('quarter')
                                    }
                                >
                                    {kedo.t('quarter')}
                                </MenuItem>

                                <MenuItem
                                    onClick={() =>
                                        this.changeDateBlocks('year')
                                    }
                                >
                                    {kedo.t('year')}
                                </MenuItem>
                            </Menu>

                            <PrintTooltipButton
                                contentRef={this.selectorRef}
                                title={kedo.t('Print')}
                            >
                                <FontAwesomeIcon icon={faPrint} />
                            </PrintTooltipButton>

                            {this.state.hiddenBlocks.length > 0 && (
                                <Tooltip title={kedo.t('Hidden')} arrow>
                                    <Button
                                        onClick={() =>
                                            this.revertHiddenBlocks()
                                        }
                                    >
                                        <FontAwesomeIcon icon={faEyeSlash} />
                                    </Button>
                                </Tooltip>
                            )}

                            <Tooltip
                                title={
                                    toggleIcon
                                        ? kedo.t('Drag is disabled')
                                        : kedo.t('Drag is enabled')
                                }
                                arrow
                            >
                                <Button onClick={this.handleToggle}>
                                    <FontAwesomeIcon
                                        icon={faToggleLargeOn}
                                        flip={
                                            toggleIcon
                                                ? 'horizontal'
                                                : 'vertical'
                                        }
                                        style={
                                            !toggleIcon
                                                ? {
                                                      '--fa-primary-color':
                                                          '#000000',
                                                      '--fa-secondary-color':
                                                          '#03bd00',
                                                  }
                                                : {}
                                        }
                                    />
                                </Button>
                            </Tooltip>

                            {kedo.isAdminOrEnvironmentAdmin() && (
                                <Select
                                    size="small"
                                    value={
                                        this.state.pos_default
                                            ? 'default_view'
                                            : 'my_view'
                                    }
                                    onChange={(e) =>
                                        this.setState(
                                            {
                                                pos_default:
                                                    e.target.value ===
                                                    'default_view',
                                            },
                                            this.setAndGetDefaultPositions
                                        )
                                    }
                                    sx={{
                                        backgroundColor: '#fff',
                                        color: brandedTokens.brand.secondary
                                            .dark,
                                        border: '1px solid',
                                        borderLeft: '0',
                                        borderColor:
                                            brandedTokens.brand.secondary.dark,
                                        borderTopLeftRadius: 0,
                                        borderBottomLeftRadius: 0,
                                        boxShadow:
                                            '0px 2px 6px rgba(0,0,0,0.15)',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                        },
                                        '&:hover': {
                                            boxShadow:
                                                '0px 4px 10px rgba(0,0,0,0.2)',
                                        },
                                        '& svg': {
                                            color: brandedTokens.brand.secondary
                                                .dark,
                                        },
                                    }}
                                >
                                    <MenuItem value="default_view">
                                        {kedo.t('Default view')}
                                    </MenuItem>

                                    <MenuItem value="my_view">
                                        {kedo.t('My view')}
                                    </MenuItem>
                                </Select>
                            )}
                        </ButtonGroup>
                    </Grid>
                </Grid>
                {this.state.subscriptionExpired ? this.renderExpired() : null}
                {hasTemplate ? (
                    <TemplateInstall
                        kedo={kedo}
                        templateId={kedo.env().getEnvironment().apply_template}
                    />
                ) : null}
                {kedo.isAdminOrEnvironmentAdmin() &&
                this.state.blocks.length > 0 ? (
                    <hr className={'statistics'} />
                ) : null}
                <div
                    ref={this.selectorRef}
                    onClickCapture={this.handleGridClickCapture}
                >
                    <ResponsiveReactGridLayout
                        className={`layout ${this.state.grayedDateBlocks}`}
                        isDraggable={this.state.toggleDrag}
                        isResizable={this.state.toggleDrag}
                        rowHeight={25}
                        breakpoints={{
                            lg: 1200,
                            md: 996,
                            sm: 768,
                            xs: 480,
                            xxs: 0,
                        }}
                        cols={{ lg: 12, md: 12, sm: 12, xs: 6, xxs: 4 }}
                        onResizeStop={() => this.setState({ moved: true })}
                        onDrag={this.handleGridDrag}
                        onDragStop={this.handleGridDragStop}
                        onLayoutChange={this.onLayoutChange}
                        layout={this.state.layout}
                    >
                        {this.state.blocks.length > 0
                            ? this.state.blocks.map((item) => {
                                  let showYScroll =
                                      item.settings?.show_y_scroll === 'yes'
                                          ? true
                                          : false
                                  let isDateFilteredBlock =
                                      (item.settings?.use_creation_date ||
                                          item.settings?.date_field) &&
                                      item.type !== 'date_statistics'

                                  return (
                                      <div
                                          key={item.uuid}
                                          className={`kedo-block d-print-block ${
                                              showYScroll === true
                                                  ? 'kedo-block-show-y'
                                                  : ''
                                          } ${
                                              isDateFilteredBlock
                                                  ? 'kedo-date-block'
                                                  : ''
                                          }`}
                                          data-grid={this.state.layout.find(
                                              (layoutItem) =>
                                                  layoutItem.i === item.uuid
                                          )}
                                      >
                                          <BlockLazy>
                                              {this.state.blockLoading ===
                                              item.id ? (
                                                  <center>
                                                      <LoadingDefault />
                                                  </center>
                                              ) : (
                                                  this.renderMyPageBlock(
                                                      item,
                                                      kedo,
                                                      false
                                                  )
                                              )}
                                          </BlockLazy>
                                      </div>
                                  )
                              })
                            : null}
                    </ResponsiveReactGridLayout>
                </div>
            </div>
        )
    }
}

export default MyPage
